var FlightDependencyItemLevel = /* @__PURE__ */ ((FlightDependencyItemLevel2) => {
  FlightDependencyItemLevel2[FlightDependencyItemLevel2["Info"] = 0] = "Info";
  FlightDependencyItemLevel2[FlightDependencyItemLevel2["Warning"] = 10] = "Warning";
  FlightDependencyItemLevel2[FlightDependencyItemLevel2["Blocking"] = 100] = "Blocking";
  return FlightDependencyItemLevel2;
})(FlightDependencyItemLevel || {});
var CompositionActionType = /* @__PURE__ */ ((CompositionActionType2) => {
  CompositionActionType2["Remove"] = "Remove";
  CompositionActionType2["Undo"] = "Undo";
  return CompositionActionType2;
})(CompositionActionType || {});
var CompositionChangeType = /* @__PURE__ */ ((CompositionChangeType2) => {
  CompositionChangeType2["Added"] = "Added";
  CompositionChangeType2["Removed"] = "Removed";
  CompositionChangeType2["None"] = "None";
  return CompositionChangeType2;
})(CompositionChangeType || {});
var FlightCompositionEditResponseItemType = /* @__PURE__ */ ((FlightCompositionEditResponseItemType2) => {
  FlightCompositionEditResponseItemType2["DependencyGraphChanged"] = "DependencyGraphChanged";
  FlightCompositionEditResponseItemType2["FlightCompositionContainsCycle"] = "FlightCompositionContainsCycle";
  FlightCompositionEditResponseItemType2["RelatedFlight"] = "RelatedFlight";
  return FlightCompositionEditResponseItemType2;
})(FlightCompositionEditResponseItemType || {});
export {
  CompositionActionType,
  CompositionChangeType,
  FlightCompositionEditResponseItemType,
  FlightDependencyItemLevel
};
//# sourceMappingURL=Composition.types.js.map
